// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CAfyO","regenerateIcon":"rV9Qe","regenerateContainer":"JJStO","backtoDefaultIcon":"ZDiPf","checkboxIcon":"ya7CM"};